import { useState, useEffect, useRef } from 'react';
var useTimer = function (isActive) {
    var _a = useState(0), seconds = _a[0], setSeconds = _a[1];
    var intervalRef = useRef(null);
    useEffect(function () {
        if (isActive) {
            setSeconds(0);
            intervalRef.current = setInterval(function () {
                setSeconds(function (prev) { return prev + 1; });
            }, 1000);
        }
        else {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            setSeconds(0);
        }
        return function () {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [isActive]);
    var formatTime = function (totalSeconds) {
        var minutes = Math.floor(totalSeconds / 60);
        var secs = totalSeconds % 60;
        return "".concat(minutes.toString().padStart(2, '0'), ":").concat(secs.toString().padStart(2, '0'));
    };
    return formatTime(seconds);
};
export var useCallTimer = function (isActive) { return useTimer(isActive); };
export var useHoldTimer = function (isActive) { return useTimer(isActive); };
